export const IMPACT_STATUS = {
  IMPACTED: 'IMPACTED',
  NOT_IMPACTED: 'NOT_IMPACTED',
  TO_BE_DETERMINED: 'TO_BE_DETERMINED',
};

export const IMPACT_LABELS = {
  IMPACTED: 'Impacted',
  NOT_IMPACTED: 'Not Impacted',
  TO_BE_DETERMINED: 'To be Determined',
};

export const isToBeDetermined = (isAffected) =>
  isAffected === null || isAffected === undefined;

export const getImpactStatusConfig = (isAffected) => {
  if (isToBeDetermined(isAffected)) {
    return {
      key: IMPACT_STATUS.TO_BE_DETERMINED,
      label: IMPACT_LABELS.TO_BE_DETERMINED,
      color: 'warning',
    };
  }
  return isAffected
    ? { key: IMPACT_STATUS.IMPACTED, label: IMPACT_LABELS.IMPACTED, color: 'error' }
    : { key: IMPACT_STATUS.NOT_IMPACTED, label: IMPACT_LABELS.NOT_IMPACTED, color: 'success' };
};
